exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.lineHg[data-v-3f1045f2] {\n  display: inline-block;\n  height: 2rem;\n  width: 0.05rem;\n  background: #ececec;\n}\n.iptBox[data-v-3f1045f2] {\n  display: inline-block;\n  height: 2.5rem;\n}\n.iptBox input[data-v-3f1045f2] {\n  height: 2.5rem;\n  width: 8.2rem;\n}\n.markClass[data-v-3f1045f2] {\n  color: #FC5D7B;\n}\n.mark[data-v-3f1045f2] {\n  display: inline-block;\n  position: absolute;\n  right: 0.75rem;\n  width: 0.75rem;\n}\n.mark img[data-v-3f1045f2] {\n  width: 100%;\n}", ""]);

// exports
